<script>
  import { fly } from "svelte/transition";
  import Tasks from "./pomodoro/Tasks.svelte";
</script>

<style>
  .pomodoro-card {
    display: grid;
    justify-content: center;
    justify-items: center;
    align-items: center;
    grid-gap: 1em;
  }
</style>

<div in:fly={{ y: 250, duration: 700 }} class="pomodoro-card">
  <Tasks />
</div>
